// DBLive device-type enum, used as the canonical wire value for
// /casino/game/load. Backend translates this per game aggregator (see
// loadgamelogic.go's to<Provider>Device / pplivePlatformFromDeviceType
// helpers), so the frontend can stay agnostic of each vendor's flavour.
//
//   1 = PC Web
//   2 = Mobile Web
//   3 = iOS
//   4 = Android
//   5 = Other
export type DeviceType = 1 | 2 | 3 | 4 | 5;

/**
 * Detect the canonical device type for the current client.
 *
 * Inside a Telegram Mini App `WebApp.platform` is the authoritative
 * signal — TG knows whether the user is on its native iOS app, its
 * native Android app, or the desktop client, and reports a stable
 * string. The web variants (`web`, `webk`, `weba`) and `unknown` fall
 * through to UA sniffing because TG itself can't tell which device the
 * browser is on.
 *
 * Outside TG we sniff `navigator.userAgent`. iOS / Android trump the
 * generic Mobile check so an iPad in desktop-mode UA still classifies as
 * a mobile device, and we only emit `5 = Other` when the runtime has no
 * navigator at all (SSR / unusual environment).
 */
/**
 * Saba Sports only accepts device_type 1 (PC) or 2 (H5/mobile).
 * Map iOS (3) / Android (4) / Other (5) → 2.
 */
export function sabaNormalizeDeviceType(dt: DeviceType): 1 | 2 {
  return dt === 1 ? 1 : 2;
}

export function detectDeviceType(): DeviceType {
  const tgPlatform =
    typeof window !== 'undefined'
      ? (window.Telegram?.WebApp as { platform?: string } | undefined)?.platform
      : undefined;

  if (tgPlatform === 'ios') return 3;
  if (tgPlatform === 'android' || tgPlatform === 'android_x') return 4;
  if (tgPlatform === 'macos' || tgPlatform === 'tdesktop') return 1;

  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  if (!ua) return 5;
  if (/iPhone|iPad|iPod/i.test(ua)) return 3;
  if (/Android/i.test(ua)) return 4;
  if (/Mobi|Mobile|Tablet/i.test(ua)) return 2;
  return 1;
}
